import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetCaracteristicaEspecial } from '../shared/interfaces/configuracion';
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class CaracteristicaEspecialService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private readonly http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/caracteristica-especial`;
  }

  getCaracteristicaEspecial(): Observable<IGetCaracteristicaEspecial[]> {
    return this.http.get<IGetCaracteristicaEspecial[]>(`${this.baseUrl}`);
  }
}
